import { Chip, ChipProps } from "@mui/material"
import { ArticleResult } from "interface/article"

type ArticleWordsChipsProps = {
	words: ArticleResult['words']
} & ChipProps
export const ArticleWordsChips = ({
	words,
	...others
}: ArticleWordsChipsProps) => {
	return words?.map((word, i) => (
		<Chip
			key={`word-${i}`}
			label={word}
			{...others}
		/>
	)) ?? <></>
}